import TagManager from 'react-gtm-module';

export const useMapTag = ({ label }) =>
  TagManager.dataLayer({
    dataLayer: {
      event: 'click_map',
      category: 'UI Interaction',
      action: 'Click',
      label
    }
  });

export const useMapViewVenueTag = ({ label }) =>
  TagManager.dataLayer({
    dataLayer: {
      event: 'click_map_view_venue',
      category: 'UI Interaction',
      action: 'Click',
      label
    }
  });
